export default __webpack_public_path__ + "static/media/sam-and-karen-staring.cb081365.jpeg";